import { ip_back } from "../config";

const MIN_DWELL_MS = 1500;
const MAX_DWELL_MS = 30 * 60 * 1000;

function postScreenView(payload) {
  try {
    const token =
      typeof localStorage !== "undefined" ? localStorage.getItem("token") : null;
    if (!token) return;
    fetch(`${ip_back}api/usage/events`, {
      method: "POST",
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ event: "screen_view", ...payload }),
      keepalive: true,
    }).catch(() => {});
  } catch {
    /* metering must not break navigation */
  }
}

/** Normalize SPA paths into stable screen keys for pilot digests. */
export function normalizeScreenPath(pathname = "/") {
  let path = String(pathname || "/").split("?")[0].split("#")[0] || "/";
  if (path.length > 1 && path.endsWith("/")) path = path.slice(0, -1);
  // Collapse dynamic ids (uuids / long alphanumeric tokens).
  path = path.replace(
    /\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi,
    "/:id"
  );
  path = path.replace(/\/(?:u|us|ur|cl|club_|ts|te|gr)[a-z0-9_-]{6,}/gi, "/:id");
  path = path.replace(/\/\d{5,}/g, "/:id");
  return path.slice(0, 64) || "/";
}

let current = null;

function flush(nextPath) {
  if (!current) return;
  const dwell = Date.now() - current.startedAt;
  if (dwell >= MIN_DWELL_MS) {
    postScreenView({
      path: current.path,
      screen: current.path,
      dwell_ms: Math.min(dwell, MAX_DWELL_MS),
      title: typeof document !== "undefined" ? document.title : null,
    });
  }
  current = nextPath
    ? { path: normalizeScreenPath(nextPath), startedAt: Date.now() }
    : null;
}

/** Call on every authenticated route change. */
export function trackScreenPath(pathname) {
  const path = normalizeScreenPath(pathname);
  if (current && current.path === path) return;
  if (!current) {
    current = { path, startedAt: Date.now() };
    return;
  }
  flush(path);
}

export function flushScreenTracking() {
  flush(null);
}

if (typeof window !== "undefined") {
  window.addEventListener("pagehide", () => flushScreenTracking());
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") flushScreenTracking();
  });
}
